export const toCssSizeUnit = (size) => {
    if (typeof size === "number" || size.match(/^[0-9]+\.?[0-9]*$/)) {
        return `${size}px`;
    }
    return size;
};
export const pxToRem = (px) => {
    const doTheMath = (unit) => unit / 16 + "rem";
    return typeof px === "string"
        ? px
            .split(" ")
            .map((part) => doTheMath(parseInt(part.replace("px", ""))))
            .join(" ")
        : doTheMath(px);
};
export const toRem = (val) => {
    if (typeof val === "string" && val.includes("rem"))
        return val;
    const size = toCssSizeUnit(val);
    return pxToRem(size.replace("px", ""));
};
// This function compiles a component's props.class to output a CSS classes string.
export const toCssClassString = (classObj, classString = "") => {
    if (!classObj)
        return "";
    if (typeof classObj === "string")
        return classObj;
    if (!Array.isArray(classObj) && typeof classObj === "object") {
        return Object.entries(classObj)
            .filter((entry) => entry[1])
            .map((entry) => entry[0])
            .join(" ");
    }
    if (Array.isArray(classObj)) {
        return [classString, ...classObj.map((item) => toCssClassString(item)).filter((item) => !!item)].join(" ").trim();
    }
    throw new Error("Unexpected error!");
};
export const mergeComponentClasses = (a, b) => {
    return [toCssClassString(a ?? []), toCssClassString(b ?? [])].join(" ").replace(/\s{2,}/g, " ");
};
